import styled from 'styled-components';
import { SvgIcon } from '../../../Icon';
import { theme } from '../../../../styles/theme';

interface IProps {
  amountOfThreads: number;
  activeIndex: number;
  onPreviousClick: () => void;
  onNextClick: () => void;
}

const Container = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  column-gap: 8px;
`;
const ArrowsWrapper = styled.div`
  flex: 0 0 auto;
  display: inline-flex;
  column-gap: 4px;
`;
const Summary = styled.div`
  flex: 0 0 auto;
  user-select: none;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

const EntityConversationThreadsPagination = ({
  amountOfThreads,
  activeIndex,
  onPreviousClick,
  onNextClick,
}: IProps) => (
  <Container>
    <ArrowsWrapper>
      <SvgIcon
        name="caret-left"
        width={16}
        height={16}
        onClick={onPreviousClick}
        isHoverable={true}
        isDisabled={activeIndex === 0}
      />
      <SvgIcon
        name="caret-right"
        width={16}
        height={16}
        onClick={onNextClick}
        isHoverable={true}
        isDisabled={activeIndex + 1 === amountOfThreads}
      />
    </ArrowsWrapper>
    <Summary>
      {activeIndex + 1} of {amountOfThreads}
    </Summary>
  </Container>
);

export default EntityConversationThreadsPagination;
